import React, { useState } from 'react';
import { User, Copy, Check } from 'lucide-react';

const FormSelector = () => {
  const [copiedId, setCopiedId] = useState(null);
  const forms = [
    {
      id: 'level1',
      title: 'Formulaire Simple',
      description: 'Remplissez le nom et prénom jusqu\'au grand parent',
      icon: User,
      color: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-50',
      route: '/oci1'
    },
    {
      id: 'level2',
      title: 'Formulaire Normal',
      description: 'Remplissez le nom, prénom jusqu\'au arrière grand parent',
      icon: User,
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-50',
      route: '/oci2'
    },
    {
      id: 'level3',
      title: 'Formulaire Avancé',
      description: 'Remplissez le nom, prénom jusqu\'au arrière grand parent et les informations de vos enfants et conjoint(e)',
      icon: User,
      color: 'bg-purple-500',
      hoverColor: 'hover:bg-purple-50',
      route: '/oci3'
    },
    {
      id: 'level4',
      title: 'Formulaire Complet',
      description: 'Remplissez le nom, prénom, lieu de naissance jusqu\'au arrière grand parent et les informations de vos enfants et conjoint(e)',
      icon: User,
      color: 'bg-orange-500',
      hoverColor: 'hover:bg-orange-50',
      route: '/oci4'
    }
  ];

  const ancestorForms = [
    {
      id: 'ancestor1',
      title: 'Formulaire Simple',
      description: 'Remplissez le nom et prénom jusqu\'au grand parent',
      icon: User,
      color: 'bg-amber-600',
      hoverColor: 'hover:bg-amber-50',
      route: '/ancetre1'
    },
    {
      id: 'ancestor2',
      title: 'Formulaire Normal',
      description: 'Remplissez le nom, prénom jusqu\'au arrière grand parent',
      icon: User,
      color: 'bg-red-600',
      hoverColor: 'hover:bg-red-50',
      route: '/ancetre2'
    },
    {
      id: 'ancestor3',
      title: 'Formulaire Avancé',
      description: 'Remplissez le nom, prénom jusqu\'au arrière grand parent et les informations de vos enfants et conjoint(e)',
      icon: User,
      color: 'bg-yellow-600',
      hoverColor: 'hover:bg-yellow-50',
      route: '/ancetre3'
    },
    {
      id: 'ancestor4',
      title: 'Formulaire complet',
      description: 'Remplissez le nom, prénom, lieu de naissance jusqu\'au arrière grand parent et les informations de vos enfants et conjoint(e)',
      icon: User,
      color: 'bg-pink-600',
      hoverColor: 'hover:bg-pink-50',
      route: '/ancetre4'
    }
  ];

  const handleFormSelection = async (route, id) => {
    try {
      const fullUrl = `${window.location.origin}${route}`;
      await navigator.clipboard.writeText(fullUrl);
      setCopiedId(id);
      
      // Réinitialiser l'état après 2 secondes
      setTimeout(() => {
        setCopiedId(null);
      }, 2000);
      
      console.log(`Lien copié: ${fullUrl}`);
    } catch (err) {
      console.error('Erreur lors de la copie:', err);
      // Fallback pour les navigateurs plus anciens
      const textArea = document.createElement('textarea');
      textArea.value = `${window.location.origin}${route}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      setCopiedId(id);
      setTimeout(() => {
        setCopiedId(null);
      }, 2000);
    }
  };

  const renderFormGrid = (formsArray) => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {formsArray.map((form) => {
        const IconComponent = form.icon;
        return (
          <div
            key={form.id}
            onClick={() => handleFormSelection(form.route, form.id)}
            className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-gray-200 transform hover:-translate-y-1 ${form.hoverColor} ${copiedId === form.id ? 'ring-2 ring-green-400' : ''}`}
          >
            <div className="p-8 text-center">
              <div className={`${form.color} w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg`}>
                <IconComponent className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{form.title}</h3>
              <p className="text-gray-600 leading-relaxed">{form.description}</p>
              <div className="mt-6">
                <div className={`inline-flex items-center px-4 py-2 ${form.color} text-white text-sm font-medium rounded-full transition-all duration-200 group-hover:shadow-lg`}>
                  {copiedId === form.id ? (
                    <>
                      <Check className="mr-2 w-4 h-4" />
                      Lien copié !
                    </>
                  ) : (
                    <>
                      <Copy className="mr-2 w-4 h-4" />
                      Copier le lien
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Demande carte OCI</h1>
          <p className="text-lg text-gray-600">Voici les formulaire pour la demande OCI</p>
        </div>

        {renderFormGrid(forms)}

        <div className="mt-16 mb-12">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Ancêtre Indien</h2>
            <p className="text-lg text-gray-600">Voici les formulaire pour la demande d'ancetre indien</p>
          </div>
        </div>

        {renderFormGrid(ancestorForms)}

        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Cliquez sur une carte pour copier le lien vers le niveau correspondant
          </p>
        </div>
      </div>
    </div>
  );
};

export default FormSelector;